/**
 * Pin Tool - Pins elements to prevent movement/deletion
 */
import { BaseTool } from './BaseTool';
import { ThreeEvent } from '@react-three/fiber';

export class PinTool extends BaseTool {
    id = 'PIN';
    name = 'Pin';
    cursor = 'default';

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        const selection = this.context?.appStore.selectedIds || [];
        if (selection.length > 0) {
            this.pinElements(selection);
        } else {
            const id = this.findElementIdAtPoint(event);
            if (id) {
                this.pinElements([id]);
            }
        }
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    private pinElements(ids: string[]) {
        if (!this.context) return;
        ids.forEach(id => {
            const el = this.context!.bimStore.project.elements.get(id);
            if (el) {
                // In a real implementation we would set a 'pinned' property
                // For now, we simulate by adding a 'Pinned' parameter
                const newParams = { ...el.parameters, 'Pinned': true };
                this.context!.bimStore.updateElement(id, { parameters: newParams });
            }
        });
        console.log('Pinned elements:', ids);
    }

    onPointerMove(): void { }
    onPointerUp(): void { }
}
